import Request from './request'

const CompanyServices  = {
  getCompanyTariffs(callback) {
    Request.get('company-services/tariffs').then(callback).catch(this.bad_answer)
  },
  getCompanyServices(callback) {
    Request.get('company-services/services').then(callback).catch(this.bad_answer)
  },
  getCompanyTariffDevices(params, callback) {
    Request.post('company-services/tariff-devices', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  addDeviceTariff(params, callback) {
    Request.post('company-services/add-device-tariff', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  createTariff(params, callback) {
    Request.post('company-services/create-tariff', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default CompanyServices
